module.exports = __webpack_public_path__ + "static/media/hm.482c4fdc.png";